module.exports = __webpack_public_path__ + "img/NoRecordFound2.d69b3cbe.svg";